import React, { Fragment, useEffect, useState } from 'react';
import { ApiBridgeAlert, ApiNote } from '../api/models';
import { Button } from 'react-bootstrap';
import StatusModal from '../common/status/StatusModal';
import Has from '../auth/Has';
import { CAN_MODIFY_ALERT, CAN_MODIFY_ALERT_THROUGH_FILTER } from '../auth/permissions';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { AppState } from '../store/store';
import { fetchAlertStatuses } from '../screening/alert-status/alertStatusesActions';
import { InternalApiAlertType, InternalApiMonitoringAlert, InternalApiManualAlert } from '../api-internal';
import { alertStatusApi } from '../apis';

export const AlertRowStatus = ({ alert, alertType, onChange }: AlertRowStatusProps) => {
  const [showModal, setShowModal] = useState(false);

  const dispatch = useDispatch();
  const onSubmit = async (note: ApiNote, selectedStatus: string) => {
    await alertStatusApi.updateAlertStatus({
      internalApiAlertStatusUpdate: {
        alertId: alert.id,
        alertType: alertType,
        note: note.content,
        status: selectedStatus,
      },
    });
    await onChange(selectedStatus);
    onChange(selectedStatus);
    setShowModal(false);
  };

  const { statuses } = useSelector((state: AppState) => state.screeningAlertStatuses, shallowEqual);
  useEffect(() => {
    if (statuses.length == 0) {
      dispatch(fetchAlertStatuses());
    }
  }, [statuses]);

  const onClose = () => {
    setShowModal(false);
  };

  return (
    <Has anyPermissions={[CAN_MODIFY_ALERT, CAN_MODIFY_ALERT_THROUGH_FILTER]}>
      {(can: boolean) =>
        can ? (
          <Fragment>
            <Button
              className='btn-white dropdown dropdown-toggle btn btn-primary btn-sm'
              onClick={() => setShowModal(!showModal)}
            >
              {statuses.find((it) => it.id == alert.statusId)?.textName}
            </Button>
            <StatusModal
              showModal={showModal}
              onSubmit={onSubmit}
              onClose={onClose}
              alertType={alertType}
              currentStatus={alert.status}
              alert={alert}
            />
          </Fragment>
        ) : (
          <div>
            <span>{statuses.find((it) => it.id == alert.statusId)?.textName}</span>
          </div>
        )
      }
    </Has>
  );
};

interface AlertRowStatusProps {
  alert: InternalApiMonitoringAlert | ApiBridgeAlert | InternalApiManualAlert;
  alertType: InternalApiAlertType;
  onChange: (status: string) => void;
}

export default AlertRowStatus;
